(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'FacilityKarcherDetailsController',
      FacilityKarcherDetailsController
    );

  /** @ngInject */
  function FacilityKarcherDetailsController(
    $scope,
    $log,
    FacilityKarcherDetailsViewModel,
    deviceActions,
    $interval,
    layoutActions,
    messagesStore,
    $state,
    $stateParams,
    dashboardKarcherActions,
    weatherKarcherActions,
    webSocketsStore,
    broker,
    $mdDialog,
    $translate,
    rolloverStatusCheck,
    checkUserRole,
    dispatcher,
    ActionTypesEnum,
    helperService,
    $timeout,
    $window
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onActuatorChangedHandler = refreshDeviceActuator,
      _onFeedChangedHandler = refreshDeviceFeed,
      _onEventChangedHandler = refreshDeviceEvent;

    vm.facility = null;
    vm.facilityVM = new FacilityKarcherDetailsViewModel();
    vm.alarmHistoryTabSelected = false;
    vm.enableRolloverButton = true;
    vm.checkBoxEnableRolloverReset = false;
    vm.showLogsHistory = false;

    vm.pageChanged = function (page, limit) {
      vm.facilityVM.alarmsPaginationChanged(page, limit);
      getAlarmsForSelectedWashFacility();
    };

    vm.sortChanged = function (order) {
      vm.facilityVM.alarmsOrderingChanged(order);
      getAlarmsForSelectedWashFacility();
    };

    vm.enableResetRolloverButton = function () {
      vm.enableRolloverButton = !vm.enableRolloverButton;
      vm.checkBoxEnableRolloverReset = vm.enableRolloverButton;
    };

    vm.resetRollover = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('RESET_ROLOVER_TITLE'))
        .textContent($translate.instant('RESET_ROLOVER_CONTENT'))
        .ariaLabel('Reset rollover')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(
        function () {
          vm.activateNow(
            vm.facilityVM.resetRolloverActuator,
            'resetRollover',
            vm.facilityVM.resetRolloverId
          );
        },
        function () {
          vm.enableRolloverButton = true;
          vm.checkBoxEnableRolloverReset = false;
        }
      );
    };

    vm.openDoorRollover = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('OPEN_ROLOVER_DOOR_TITLE'))
        .textContent($translate.instant('OPEN_ROLOVER_DOOR_CONTENT'))
        .ariaLabel('Open the door')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(
        function () {
          vm.activateNow(
            vm.facilityVM.openDoorsActuator,
            'openDoors',
            vm.facilityVM.openDoorsId
          );
        },
        function () {}
      );
    };

    vm.activateNow = function (data, type, parentPointId) {
      // Check user role
      if (
        checkUserRole.isMerchantAdmin() ||
        checkUserRole.isTechnicalSupportUser()
      ) {
        if (!data || !Array.isArray(data)) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('ACTUATION_NOT_AVAILABLE')
            }
          });
          return;
        }

        var pointId = null;
        switch (type) {
          case 'speed':
            pointId = vm.facilityVM.speedsPointId;
            break;
          case 'dosing':
            pointId = vm.facilityVM.dosingPointId;
            break;
          case 'parameters':
            pointId = vm.facilityVM.parametersPointId;
            break;
          default:
            pointId = parentPointId;
            break;
        }

        data.forEach(function (item) {
          try {
            if (decodeURIComponent(item.value) === item.value) {
              item.value = encodeURIComponent(item.value);
            }
          } catch (e) {
            item.value = encodeURIComponent(item.value);
          }
        });

        deviceActions
          .groupActuate(vm.facilityVM.deviceSerial, pointId, data)
          .then(function () {
            if (
              type === 'operationTime' ||
              type === 'washingPrograms' ||
              type === 'pumps'
            ) {
              layoutActions.showLoader();
              getKarcherDevices();
            }
          });
        return;
      }
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_TOASTER_MSG,
        payload: {
          type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
          message: $translate.instant('ACTUATION_NOT_ALLOWED')
        }
      });
    };

    vm.checkMachineTypeName = function () {
      return vm.facilityVM.machineType.includes('CB3');
    };

    vm.rolloverNormalStatus = function () {
      return rolloverStatusCheck.normalStatus(vm.facilityVM.rolloverStatus);
    };

    vm.rolloverAlertStatus = function () {
      return rolloverStatusCheck.alertStatus(vm.facilityVM.rolloverStatus);
    };

    vm.rolloverUndefinedStatus = function () {
      return rolloverStatusCheck.undefinedStatus(vm.facilityVM.rolloverStatus);
    };

    vm.refreshOperatingData = function () {
      getKarcherDevices();
    };

    vm.pullNewEventData = function () {
      getEventsList();
    };

    vm.startService = function (ev, box) {
      $mdDialog.show({
        templateUrl: 'app/facilityDetails/insert-token-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        controller: DialogInsertTokenController,
        controllerAs: 'vm',
        bindToController: true,
        locals: {
          box: box,
          facilityId: vm.facilityVM.facilityId
        }
      });

      function DialogInsertTokenController(
        $mdDialog,
        box,
        managingTokensActions,
        facilityId,
        dispatcher,
        ActionTypesEnum
      ) {
        var vm = this;
        vm.box = box;
        vm.dialogData = {};
        vm.buttonTitle = $translate.instant('IN_PROGRESS');
        vm.sessionStatus = '';

        managingTokensActions
          .createDeviceSession(box.pointId)
          .then(function (response) {
            vm.sessionStatus = response.data.status;
            vm.buttonTitle = $translate.instant('INSERT');
          });

        vm.closeDialog = function () {
          $mdDialog.cancel();
        };

        vm.saveToken = function (token) {
          if (token && vm.sessionStatus === 'PENDING') {
            managingTokensActions
              .startDeviceService(facilityId, box.pointId, token)
              .then(function () {
                $mdDialog.hide(token);
              });
          } else {
            $mdDialog.hide(token);
            dispatcher.dispatch({
              type: ActionTypesEnum.SHOW_TOASTER_MSG,
              payload: {
                type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                message: $translate.instant('EXPIRED_SESSION')
              }
            });
          }
        };
      }
    };

    vm.printQrCode = function () {
      var printWindow = $window.open('', '_blank');
      /* eslint-disable */
      $timeout(function () {
        var qrElement = angular.element(
          document.querySelector('.qr-code-wrapper')
        );
        /* eslint-enable */
        if (!qrElement.length) {
          return;
        }

        var qrCodeCanvas = qrElement[0].querySelector('canvas');
        var qrCodeImage = '';

        if (qrCodeCanvas) {
          qrCodeImage = qrCodeCanvas.toDataURL('image/png');
        }

        var content = [
          '<html>',
          '<head>',
          '<title>QR Code</title>',
          '<style>',
          'body { margin: 0; padding: 20px; }',
          '.print-container { text-align: center; }',
          '.qr-code { margin-bottom: 10px; }',
          '.facility-id { font-family: Arial, sans-serif; font-size: 14px; }',
          '@media print {',
          '    @page { margin: 0; }',
          '    body { margin: 1.6cm; }',
          '}',
          '</style>',
          '</head>',
          '<body>',
          '<div class="print-container">',
          qrCodeImage ? '<img src="' + qrCodeImage + '" alt="QR Code"/>' : '',
          '<p class="facility-id">' +
            vm.facilityVM.facilityIdForQrCode +
            '</p>',
          '</div>',
          '<script>',
          'window.onload = function() {',
          '    window.print();',
          '    window.onafterprint = function() { window.close(); };',
          '};',
          '</script>',
          '</body>',
          '</html>'
        ].join('');

        printWindow.document.write(content);
        printWindow.document.close();
      }, 500);
    };

    vm.editLabelName = function(ev, deviceData) {
      $mdDialog
        .show({
          controller: "ChangeDeviceLabelNameController",
          controllerAs: "vm",
          templateUrl:
            "app/karcherCustomDialogs/changeDeviceLabelName/changeDeviceLabelName.html",
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: deviceData },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            deviceActions.changeDeviceLabelName(data).then(function () {
              getKarcherDevices();
            })
          },
          function () {}
        );
    }

    init();

    function init() {
      vm.facilityVM.siteAddress = $stateParams.siteAddress;
      vm.facilityVM.siteLatitude = $stateParams.siteLatitude;
      vm.facilityVM.siteLongitude = $stateParams.siteLongitude;
      getWeather();
      if (!webSocketsStore.isConnected()) {
        broker.initWebSockets();
      }
      $scope.$on('$destroy', destroy);
      layoutActions.showLoader();
      getKarcherDevices();
    }

    // Temporary, delete when testing is done
    vm.displayDebugTab = helperService.getDevelopAccess();

    function getKarcherDevices() {
      dashboardKarcherActions
        .getKarcherDeviceDetailsById($stateParams.id, $stateParams.deviceId)
        .then(function (response) {
          vm.facilityVM.refreshFacilityData(response);
          getAlarmsForSelectedWashFacility();
          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
            _onActuatorChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_EVENT_CHANGE,
            _onEventChangedHandler
          );
          // getEventsList();
        });
    }

    function getAlarmsForSelectedWashFacility() {
      if (vm.facilityVM.facilityType === 'CHANGER') {
        dashboardKarcherActions.getChangerAlarms(vm.facilityVM.deviceId).then(function (alarms) {
          vm.facilityVM.refreshChangerAlarmList(alarms);
        });
      } else {
        dashboardKarcherActions
          .getKarcherSiteAlarmList(
            '',
            '',
            vm.facilityVM.facilityId ? vm.facilityVM.facilityId : '',
            '&sitePointId=',
            '',
            '',
            vm.facilityVM.alarmsPage - 1,
            vm.facilityVM.alarmsPageSize,
            vm.facilityVM.alarmsOrderBy,
            vm.facilityVM.alarmsOrder
          )
          .then(function (response) {
            vm.facilityVM.refreshAlarmList(response);
          });
      }
    }

    function getEventsList() {
      layoutActions.showLoader();
      dashboardKarcherActions
        .getEventsListForSelectedDevice(vm.facilityVM.deviceSerial)
        .then(function () {
          $log.log(
            $translate.instant('DEVICE_EVENTS_LOG_PULLED') +
              vm.facilityVM.deviceSerial
          );
          $timeout(function () {
            layoutActions.hideLoader();
          }, 10000);
        });
    }

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        broker.subscribeToFeedChanges([vm.facilityVM.deviceSerial]);
        broker.subscribeToActuatorChanges([vm.facilityVM.deviceSerial]);
        broker.subscribeToEventChanges([vm.facilityVM.deviceSerial]);
      }
    }

    function refreshDeviceFeed(newFeedData) {
      if (newFeedData.data.reference === 'CURRENT_FAULTS') {
        getAlarmsForSelectedWashFacility();
      }
      vm.facilityVM.updateFeedValues(newFeedData);
    }

    function refreshDeviceActuator(newActuatorData) {
      vm.facilityVM.updateActuatorValues(newActuatorData);
    }

    function refreshDeviceEvent(newEventData) {
      vm.facilityVM.updateEventValues(newEventData);
    }

    function getWeather() {
      weatherKarcherActions
        .getCurrentWeather(
          vm.facilityVM.siteLatitude,
          vm.facilityVM.siteLongitude
        )
        .then(function (currentWeather) {
          vm.facilityVM.currentWeatherData = {
            country: currentWeather.location.country,
            city: currentWeather.location.name,
            region: currentWeather.location.region,
            temperature: currentWeather.current.temp_c,
            pressure: currentWeather.current.pressure_mb,
            currentWeatherIcon: currentWeather.current.condition.icon,
            currentWeatherTime: currentWeather.location.localtime
          };
        });
    }

    function destroy() {
      if (broker.isConnected()) {
        broker.unsubscribeSocket();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_FEED_CHANGE,
          _onFeedChangedHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
          _onActuatorChangedHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_EVENT_CHANGE,
          _onEventChangedHandler
        );
      }
      vm.facilityVM.deviceSerial = '';
    }
  }
})();
